import { ClientDashboardUpcomingMeetingDto } from '@hoqus/connectis-client-dashboard-types';
import { MeetingType } from './MeetingType.ts';

export const mapDtoToMeetingType = (dto: ClientDashboardUpcomingMeetingDto): MeetingType => ({
  title: dto.title,
  url: dto.url,
  displayDate: dto.displayDate,
  displayTime: dto.displayTime,
});
